import { FieldDisplayRenderWrapper } from "../components/FieldDisplayRenderWrapper.js";
import { useMemo } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/FormBuilder/components/Fields/Label/Display.tsx
var LabelDisplay = ({ config }) => {
	const style = useMemo(() => {
		const s = {};
		if (config.options.alignX) {
			s.display = "flex";
			switch (config.options.alignX) {
				case "left":
					s.justifyContent = "start";
					s.textAlign = "left";
					break;
				case "center":
					s.textAlign = "center";
					s.justifyContent = "center";
					break;
				case "right":
					s.textAlign = "right";
					s.justifyContent = "end";
					break;
				default: s.justifyContent = "start";
			}
		}
		if (config.options.bgColor) s.backgroundColor = config.options.bgColor;
		if (config.options.textColor) s.color = config.options.textColor;
		if (config.options.mY) {
			s.marginBottom = config.options.mY * 5 + "%";
			s.marginTop = config.options.mY * 5 + "%";
		}
		if (config.options.mX) {
			s.marginLeft = config.options.mX * 5 + "%";
			s.marginRight = config.options.mX * 5 + "%";
		}
		if (config.options.pY) {
			s.paddingBottom = config.options.pY * 5 + "%";
			s.paddingTop = config.options.pY * 5 + "%";
		}
		if (config.options.pX) {
			s.paddingLeft = config.options.pX * 5 + "%";
			s.paddingRight = config.options.pX * 5 + "%";
		}
		return s;
	}, [config.options]);
	return /* @__PURE__ */ jsx(FieldDisplayRenderWrapper, {
		config,
		children: /* @__PURE__ */ jsxs("div", {
			className: "flex flex-col rounded",
			style,
			children: [/* @__PURE__ */ jsx("div", {
				className: `text-${config.options.fontSize}`,
				children: config.options.label
			}), config.options.subText && /* @__PURE__ */ jsx("div", {
				className: "text-color-subtle text-sm",
				children: config.options.subText
			})]
		})
	});
};
//#endregion
export { LabelDisplay };

//# sourceMappingURL=Display.js.map